export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/service2.d825be0f.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};